<template>
  <div>
    <v-row no-gutters>
      <v-col>
        <div id="landing">
          <Menu />
          <v-app-bar
            class="navigation"
            elevation="0"
            style="background: none !important"
          >
            <v-avatar color="primary" size="50">
              <v-img
                contain
                lazy-src="../../assets/img/logo-teman-bakat.png"
                max-height="150"
                max-width="250"
                src="../../assets/img/logo-teman-bakat.png"
              ></v-img>
            </v-avatar>
            <template>
              <v-tabs align-with-title v-model="tab">
                <v-tab href="http://temanbakat.id" target="_blank">
                  BERANDA
                </v-tab>
                <v-tab
                  v-for="item in menuItems"
                  :key="item.name"
                  @click="onItem = item.id"
                >
                  {{ item.text }}
                </v-tab>
              </v-tabs>
            </template>
          </v-app-bar>
          <div id="mobile-landing" class="d-flex justify-center align-center">
            <div style="width: 50%; margin-top: 20%" class="pl-5">
              <v-card
                elevation="4"
                height="100%"
                width="100%"
                class="
                  text-center
                  rounded-xl
                  animate__animated animate__backInDown
                  d-flex
                  justify-center
                  align-center
                "
                style="background: #542a6c; color: white; cursor: pointer"
                @click="toKatalog"
              >
                <p class="pa-4" style="font-weight: 700; font-size: 10px">
                  Klik <span style="color: #f4d13b">di sini</span> <br />
                  untuk menemukan
                  <span style="color: #f4d13b">Jurusan Kuliah</span> yang
                  <span style="color: #f4d13b">tepat buatmu!</span>
                </p>
              </v-card>
            </div>
            <div style="width: 50%"></div>
          </div>
        </div>
      </v-col>
    </v-row>
    <v-row no-gutters>
      <v-col cols="12" md="12" sm="12">
        <div id="banner-top" class="d-flex justify-center align-center">
          <div class="banner-top-sub">
            <v-card
              elevation="4"
              height="100%"
              width="100%"
              class="
                pa-2
                text-center
                rounded-lg
                animate__animated animate__backInDown
                d-flex
                justify-center
                align-center
              "
              style="background: #542a6c; color: white; cursor: pointer"
              @click="toKatalog"
            >
              <div>
                <p style="font-weight: 700">
                  Klik <span style="color: #f4d13b">di sini</span><br />
                  untuk menemukan
                  <span style="color: #f4d13b">Jurusan Kuliah</span> yang
                  <span style="color: #f4d13b">tepat buatmu!</span>
                </p>
              </div>
            </v-card>
          </div>
        </div>
      </v-col>
    </v-row>
    <v-row no-gutters>
      <v-col cols="12" md="12" sm="12">
        <div id="card-search" class="d-flex justify-center">
          <div class="card-search-sub">
            <v-card
              elevation="4"
              height="100%"
              width="100%"
              class="
                text-center
                rounded-lg
                animate__animated animate__backInDown
              "
            >
              <v-card-text
                class="text-h4 font-weight-bold py-15"
                style="color: #23003a"
              >
                Mau Cari Jurusan Apa?
                <v-card-text class="mt-n4">
                  Yuk, cari tahu informasi jurusan kuliah untukmu agar tidak
                  salah pilih!
                </v-card-text>
                <div
                  class="wrap-search-input d-flex justify-center align-center"
                >
                  <v-text-field
                    placeholder="Cari di sini"
                    solo
                    flat
                    hide-details
                    @keyup="getRecommend"
                    class="rounded-xl input-search"
                    background-color="#E8E5EB"
                    v-model="search"
                  ></v-text-field>
                  <v-btn
                    class="mx-2"
                    fab
                    small
                    dark
                    color="#41006B"
                    @click="searching"
                    href="#row-card"
                  >
                    <v-icon dark> mdi-magnify </v-icon>
                  </v-btn>
                </div>
              </v-card-text>
            </v-card>
          </div>
        </div>
      </v-col>
    </v-row>
    <v-row
      class="mt-12 ml-n12"
      v-if="search != ''"
      no-gutters
      style="z-index: 4"
    >
      <v-col md="12" class="d-flex justify-center align-center">
        <v-card
          width="35%"
          height="200px"
          style="overflow: auto; position: absolute"
          class="card-recomended"
        >
          <div v-if="recomendedJurusan && !isLoading">
            <div
              class="px-5 pt-3 pb-1 d-flex item-recomended"
              v-for="item in recomendedJurusan"
              :key="item.id"
              @click="onClickRecomended(item.jurusan_nama)"
            >
              <v-icon class="mr-2">mdi-magnify</v-icon>
              <p class="ma-0">{{ item.jurusan_nama }}</p>
            </div>
          </div>
          <div
            v-if="recomendedJurusan.length == 0 && !isLoading"
            class="d-flex justify-center align-center"
          >
            <div class="mt-12">Data tidak tersedia...</div>
          </div>
          <div v-if="isLoading" class="d-flex justify-center align-center">
            <div class="mt-12">Mencari data...</div>
          </div>
        </v-card>
      </v-col>
    </v-row>
    <v-container class="containerz">
      <v-row no-gutters class="mt-10 mb-5">
        <v-col class="d-flex" cols="12" md="6">
          <div width="50%">
            <v-menu offset-y nudge-bottom="10px">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  :color="filterText.length ? '#41006B' : 'white'"
                  :dark="filterText.length ? true : false"
                  class="ml-3 animate__animated animate__pulse font-weight-bold"
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon class="mr-2">mdi-filter-variant</v-icon>
                  <v-text
                    :color="filterText.length ? '#23003A' : 'white'"
                    :dark="filterText.length ? true : false"
                    >Filter Jurusan</v-text
                  >
                  <v-icon class="ml-2">mdi-arrow-down-drop-circle</v-icon>
                </v-btn>
              </template>
              <v-card>
                <div class="pa-5">
                  <div class="font-weight-bold">Kategori Jurusan</div>
                  <div>
                    <v-divider></v-divider>
                  </div>
                  <div class="d-flex">
                    <v-row>
                      <v-col cols="12" md="6">
                        <div
                          v-for="(item, i) in kategori1"
                          :key="i"
                          class="pa-2"
                          @click="filterKategori(item)"
                          style="cursor: pointer"
                        >
                          {{ item.text }}
                        </div>
                      </v-col>
                      <v-col cols="12" md="6">
                        <div
                          v-for="(item, i) in kategori2"
                          :key="i"
                          class="pa-2"
                          @click="filterKategori(item)"
                          style="cursor: pointer"
                        >
                          {{ item.text }}
                        </div>
                      </v-col>
                    </v-row>
                  </div>
                </div>
              </v-card>
            </v-menu>
          </div>
        </v-col>
      </v-row>
      <v-row no-gutters>
        <v-row>
          <v-col
            cols="12"
            md="12"
            v-if="filterText.length !== 0"
            class="d-flex align-center pa-5"
          >
            <div v-for="filter in filterText" :key="filter">
              <v-card class="pa-2 rounded-lg mx-2" color="#9C6FB5" dark>
                {{ filter }}
                <v-icon
                  dark
                  style="cursor: pointer"
                  @click="removeFilter(filter)"
                  >mdi-close-circle</v-icon
                >
              </v-card>
            </div>
          </v-col>
        </v-row>
      </v-row>
      <v-row no-gutters id="row-card">
        <v-col
          v-for="jurusan in dataJurusan"
          :key="jurusan.id"
          cols="12"
          md="4"
          sm="12"
        >
          <div class="pa-3">
            <v-card
              class="jurusan-card ma-auto rounded-xl"
              @click="toDetail(jurusan.id)"
              height="400px"
            >
              <v-img
                class="white--text align-end"
                height="200px"
                :src="jurusan.image_jurusan"
              >
              </v-img>
              <v-card-text class="text--primary rounded-xl" height="100%">
                <div>
                  <div style="max-width: 80%" class="rounded-lg">
                    <div
                      class="badges rounded-lg"
                      :style="`background:${jurusan.base_color};color:white;`"
                    >
                      {{ jurusan.kategori_jurusan_id }}
                    </div>
                  </div>
                  <div style="z-index: 10">
                    <div class="text-h6">{{ jurusan.jurusan_nama }}</div>
                    <div class="d-flex">
                      <div>
                        <v-avatar color="primary" size="40">
                          <v-img
                            contain
                            lazy-src="../../assets/img/logo-teman-bakat.png"
                            max-height="150"
                            max-width="250"
                            src="../../assets/img/logo-teman-bakat.png"
                          ></v-img>
                        </v-avatar>
                      </div>
                      <div class="ml-2">
                        <div>Pelajaran terkait:</div>
                        <div
                          v-for="pelajaran in jurusan.pelajaran_terkait_id"
                          :key="pelajaran"
                        >
                          {{ pelajaran }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </v-card-text>
            </v-card>
          </div>
        </v-col>
      </v-row>
      <v-row
        class="d-flex justify-center align-center mt-5"
        style="width: 100%"
        v-if="dataJurusan.length == 0"
        no-gutters
      >
        <p style="color: #23003a; text-align: center">
          Yah, jurusan yang kamu cari tidak ada! Coba gunakan kata kunci lain.
        </p>
      </v-row>
      <v-row v-if="dataJurusan.length == 0" no-gutters>
        <div class="d-flex justify-center align-center" style="width: 100%">
          <v-img
            contain
            lazy-src="../../assets/img/penjurusan/no_data.png"
            max-height="325"
            max-width="300"
            src="../../assets/img/penjurusan/no_data.png"
          ></v-img>
        </div>
      </v-row>
      <v-row class="paginate" no-gutters>
        <v-col>
          <div class="my-10 d-flex justify-center align-center">
            <div
              style="background-color: #f5f5f5"
              class="rounded-xl"
              v-if="pagination"
            >
              <div class="pa-3" v-if="filterText.length == 0">
                <v-btn
                  v-for="i in pagination.last_page"
                  :key="i"
                  class="pagination-button mx-2"
                  fab
                  :color="onPage == i ? 'purple' : 'white'"
                  :dark="onPage == i ? true : false"
                  small
                  depressed
                  href="#row-card"
                  @click="changePage(i)"
                >
                  {{ i }}
                </v-btn>
              </div>
            </div>
          </div>
        </v-col>
      </v-row>
    </v-container>
    <banner-bottom-a />
    <Footer />
    <div class="bubble-ads" id="bubble">
      <v-img
        @click="toKatalog"
        src="../../assets/img/penjurusan/bubble_ads.png"
      ></v-img>
    </div>
  </div>
</template>

<script>
import Footer from "../../components/penjurusan/Footer.vue";
import Menu from "../../components/penjurusan/Menu.vue";
import BannerBottomA from "./bannerBottomA.vue";

export default {
  name: "Landing",
  components: {
    Footer,
    Menu,
    BannerBottomA,
  },
  data: () => ({
    kategori1: [
      {
        text: "Budaya & Bahasa",
      },
      {
        text: "Ekonomi & Bisnis",
      },
      {
        text: "Kesehatan",
      },
      {
        text: "Komputer & Teknologi",
      },
      {
        text: "Pendidikan",
      },
      {
        text: "Teknik",
      },
    ],
    kategori2: [
      {
        text: "Pertanian",
      },
      {
        text: "Profesi & Ilmu Terapan",
      },
      {
        text: "Sains",
      },
      {
        text: "Seni",
      },
      {
        text: "Sosial Humaniora",
      },
    ],
    model1: 1,
    model2: 1,
    dataJurusan: [],
    recomendedJurusan: [],
    filterText: [],
    onItem: 2,
    menuItems: [{ id: 2, name: "cari-jurusan", text: "Cari Jurusan" }],
    tab: 1,
    search: "",
    pagination: null,
    onPage: 1,
    menu: false,
    drawer: false,
    group: null,
    isLoading: false,
  }),
  mounted() {
    this.getData();
    window.onscroll = function () {
      console.log("inner height", window.innerHeight);
      console.log("scroll Y", window.scrollY);
      console.log("offset height", document.body.offsetHeight);
      let bubble = document.getElementById("bubble");
      if (
        window.innerHeight + window.scrollY >=
        document.body.offsetHeight - 280
      ) {
        console.log("false result");
        bubble.style.bottom = "45%";
        console.log(bubble.style.position);
      } else {
        console.log("true result");
        bubble.style.bottom = "2%";
      }
    };
  },
  methods: {
    getData() {
      this.$store
        .dispatch("dataJurusan")
        .then((data) => {
          let dataJurusan = data.data.data;
          this.dataJurusan = dataJurusan;
          this.pagination = data.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    toDetail(id) {
      this.$router.push(`/penjurusan/detail/${id}`);
    },
    filterKategori(item) {
      this.filterText.push(item.text);
      let filter = this.filterText.toString();
      let data = {
        filter: filter,
      };
      this.$store
        .dispatch("dataJurusan", data)
        .then((data) => {
          let dataJurusan = data.data.data;
          this.dataJurusan = dataJurusan;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    removeFilter(item) {
      let newFilter = [];
      this.filterText.map(function (text) {
        if (item !== text) {
          newFilter.push(text);
        }
      });
      this.filterText = newFilter;
      let filter = this.filterText.toString();
      let data = {
        filter: filter,
      };
      this.$store
        .dispatch("dataJurusan", data)
        .then((data) => {
          let dataJurusan = data.data.data;
          this.dataJurusan = dataJurusan;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    searching() {
      let searching = this.search;
      let data = {
        search: searching,
      };
      this.$store
        .dispatch("dataJurusan", data)
        .then((data) => {
          let dataJurusan = data.data.data;
          this.dataJurusan = dataJurusan;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    changePage(page) {
      let pageNumber = page;
      let data = {
        pageNumber: pageNumber,
      };
      this.$store.dispatch("dataJurusan", data).then((data) => {
        let dataJurusan = data.data.data;
        this.dataJurusan = dataJurusan;
        this.pagination = data.data;
        this.onPage = page;
      });
    },
    getRecommend() {
      let data = {
        search: this.search,
      };
      this.isLoading = true;
      setTimeout(() => {
        this.$store
          .dispatch("dataJurusan", data)
          .then((data) => {
            this.isLoading = false;
            let recomendedJurusan = data.data.data;
            this.recomendedJurusan = recomendedJurusan;
          })
          .catch((err) => {
            console.log(err);
          });
      }, 2500);
    },
    onClickRecomended(item) {
      let data = {
        search: item,
      };
      this.$store
        .dispatch("dataJurusan", data)
        .then((data) => {
          this.search = "";
          let dataJurusan = data.data.data;
          this.dataJurusan = dataJurusan;
          this.pagination = data.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    toKatalog() {
      let vm = this;
      vm.$router.push("/penjurusan/katalog");
    },
  },
};
</script>

<style>
#landing {
  width: 100%;
  height: 65vh;
  background-image: url("../../assets/img/penjurusan/asset1.png");
  background-size: cover;
}

#card-search {
  margin-top: -10%;
}

.wrap-search-input {
  padding: 0px 50px;
}

.card-search-sub {
  width: 50%;
}

.rounded-card {
  border-radius: 80%;
}

.badges {
  padding: 5px;
  max-width: 100%;
  position: absolute;
  top: 45%;
}

.jurusan-card:hover {
  animation: pulse;
  animation-duration: 2s;
}

.pagination-button:hover {
  animation: pulse;
  animation-duration: 2s;
}

.input-search {
  width: 100%;
}
a {
  text-decoration: none;
}

.item-recomended {
  cursor: pointer;
}

.item-recomended:hover {
  font-weight: bold;
}

#menu-burger {
  display: none !important;
}

#banner-top {
  margin-top: -17%;
}

.banner-top-sub {
  width: 50%;
}

#mobile-landing {
  display: none !important;
}

.bubble-ads {
  position: fixed;
  bottom: 2%;
  left: 2%;
  width: 30%;
  object-fit: cover;
  z-index: 5;
  cursor: pointer;
  transition: 0.5s;
}

@media (max-width: 925px) {
  .card-search-sub {
    width: 70%;
  }
  .wrap-search-input {
    padding: 0px 20px;
  }
}
@media (max-width: 768px) {
  .card-search-sub {
    width: 80%;
  }
  .wrap-search-input {
    padding: 0px 10px;
  }
}
@media (max-width: 396px) {
}

@media (max-width: 576px) {
  #landing {
    background-color: #eee9f3;
    background-image: url("../../assets/img/penjurusan/asset-solo.png");
    background-size: 70%;
    background-position: bottom right;
  }
  #mobile-landing {
    display: flex !important;
  }
  #card-search {
    margin-top: -40%;
  }
  #banner-top {
    display: none !important;
  }
  .card-search-sub {
    width: 90%;
  }
  .wrap-search-input {
    padding: 0;
  }
  .paginate {
    display: none !important;
  }
  .navigation {
    display: none !important;
  }
  #menu-burger {
    display: inline !important;
  }
  .card-recomended {
    width: 80% !important;
    margin-left: 12% !important;
    height: 300px;
  }
  .containerz {
    margin-top: 20%;
  }
  .bubble-ads {
    width: 80%;
  }
}
</style>
